/* eslint-disable no-undef */
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { Environment } from './types';
import dataMiddleware from './reduxStore/data/middleware';
import dataReducer from './reduxStore/data/reducer';
import dataState from './reduxStore/data/state';
import navigationMiddleware from './reduxStore/navigation/middleware';
import navigationReducer from './reduxStore/navigation/reducer';
import navigationState from './reduxStore/navigation/state';

const rootReducer = combineReducers({
  data: dataReducer,
  navigation: navigationReducer,
});

const preloadedState = {
  data: dataState,
  navigation: navigationState,
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState,
  devTools: process.env.ENVIRONMENT !== Environment.prod,
  middleware: [dataMiddleware, navigationMiddleware],
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;
export const useAppDispatch: () => AppDispatch = useDispatch; // Export a hook that can be reused to resolve types

export default store;
